import axios from 'axios';
import { get, post, postWithDownloadFile, put, remove } from './mainApi';
import moment from 'moment';
import { generateId } from 'src/utils/traceIdGenerations';

const BaseURL = process.env.REACT_APP_PROJECT_MANAGEMENT_ENDPOINT;
const ProjectBaseURL = process.env.REACT_APP_TIME_LOG_ENDPOINT;

export const getQuickAccess = async () => {
  const response = get(`${BaseURL}quick-response`);
  return response;
};

export const AddProjectDetail = async (project) => {
  var response = post(`${BaseURL}`, project);
  return response;
};

export const UpdateProjectDetail = async (project) => {
  var response = put(`${BaseURL}`, project);
  return response;
};

export const getProjectNature = async () => {
  const response = get(`${BaseURL}project-nature`);
  return response;
};

export const addProjectNature = async (name) => {
  const response = post(`${BaseURL}project-nature`, { name });
  return response;
};

export const updateNature = async (data) => {
  const response = put(`${BaseURL}project-nature`, data);
  return response;
};

export const deleteProjectNature = async (name) => {
  const response = remove(`${BaseURL}project-nature/${name}`);
  return response;
};

export const getProjectBilling = async () => {
  const response = get(`${BaseURL}billing-category`);
  return response;
};

export const addProjectBilling = async (name) => {
  const response = post(`${BaseURL}billing-category`, { name });
  return response;
};

export const updateBilling = async (data) => {
  const response = put(`${BaseURL}billing-category`, data);
  return response;
};

export const deleteProjectBilling = async (name) => {
  const response = remove(`${BaseURL}billing-category/${name}`);
  return response;
};

export const getProjectStatus = async () => {
  const response = get(`${BaseURL}project-status`);
  return response;
};

export const addProjectStatus = async (name) => {
  const response = post(`${BaseURL}project-status`, { name });
  return response;
};

export const updateStatus = async (data) => {
  const response = put(`${BaseURL}project-status`, data);
  return response;
};

export const deleteProjectStatus = async (name) => {
  const response = remove(`${BaseURL}project-status/${name}`);
  return response;
};

export const getSalesStage = async () => {
  const response = get(`${BaseURL}sales-stage`);

  return response;
};

export const addSalesStage = async (name) => {
  const response = post(`${BaseURL}sales-stage`, { name });
  return response;
};

export const updateSalesStage = async (data) => {
  const response = put(`${BaseURL}sales-stage`, data);
  return response;
};

export const deleteSalesStage = async (name) => {
  const response = remove(`${BaseURL}sales-stage/${name}`);
  return response;
};

export const getAllProjects = async () => {
  var response = get(`${BaseURL}`);
  return response;
};

export const getAllProjectsInternal = async () => {
  var response = get(`${BaseURL}internal`);
  return response;
};

export const getAllProjectsGroupedByClients = async () => {
  var response = get(`${BaseURL}grouped-by-clients`);
  return response;
};

export const searchProjects = async (groupName: string) => {
  var response = get(`${BaseURL}filter-name?name=${groupName}`);
  return response;
};

export const searchProjectFilter = async (data) => {
  var response = post(BaseURL + 'fileter', data);
  return response;
};

export const searchProjectFilterGroupedByClients = async (data) => {
  var response = post(BaseURL + 'filter-grouped-by-clients', data);
  return response;
};

export const getSingleProject = async (code: string) => {
  var response = get(`${BaseURL}id?Id=${code}`);
  return response;
};

export const getLatestAccount = async () => {
  var response = get(`${BaseURL}project-account/latest`);
  return response;
};

export const getAllAccounts = async () => {
  var response = get(`${BaseURL}project-account`);
  return response;
};

export const AddAccount = async (project) => {
  var response = post(`${BaseURL}project-account`, project);
  return response;
};

export const getSingleAccount = async (id: string) => {
  var response = get(`${BaseURL}project-account/accountId?Id=${id}`);
  return response;
};

export const UpdateAccount = async (project) => {
  var response = put(`${BaseURL}project-account`, project);
  return response;
};

export const searchAccounts = async (accountName: string) => {
  var response = get(`${BaseURL}project-account/search?name=${accountName}`);
  return response;
};

export const DeleteAccount = async (projectId) => {
  var response = remove(`${BaseURL}project-account/${projectId}`);
  return response;
};

export const AddExternalLead = async (lead) => {
  var response = post(`${BaseURL}external-lead`, lead);
  return response;
};

export const getStakeholderRole = async () => {
  const response = get(`${BaseURL}stakeholder-role`);
  return response;
};

export const addStakeholderRole = async (value) => {
  const response = post(`${BaseURL}stakeholder-role`, { value });
  return response;
};

export const deleteStakeholderRole = async (value) => {
  const response = remove(`${BaseURL}stakeholder-role/${value}`);
  return response;
};

export const updateStakeholderRole = async (value) => {
  const response = put(`${BaseURL}stakeholder-role`, value);
  return response;
};

export const getProjectsByCustomerId = async (id) => {
  var response = get(`${BaseURL}by-customer?customerId=${id}`);
  return response;
};

export const getProjectsInternal = async () => {
  let response = get(`${BaseURL}internal`);
  return response;
};

export const getProjectManagerAvailability = async (employeeId) => {
  const response = get(`${BaseURL}project-manager-check?employeeId=${employeeId}`);
  return response;
};

export const downloadProjectsTeamsReport = async (data) => {
  try {
    let newUrl = `${BaseURL}team-report`;
    const response = postWithDownloadFile(newUrl, {
      projectCode: data.projectCode,
      role: data.role,
      resourceType: data.resourceType,
      status: data.status,
      roleType: data.roleType,
      startDate: data.startDate,
      endDate: data.endDate,
      trackCode: data.trackCode
    }, 'arraybuffer');
    return response;
  } catch (error) {}
};

export const getAllProjectsFilter = async ( customerIds) => {
  const requestBody = {
    customerIds: customerIds,
  };

  const traceId = generateId(9);

  try {
    const response = await axios.post(
      `${ProjectBaseURL}time-entry/get_filter_projects?traceId=${traceId}`,
      requestBody,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('access_token')}`,
          'Content-Type': 'application/json',
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};